module.exports = __webpack_public_path__ + "static/img/tc_wedding.8ce8f24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/tc_wedding.jpg
// module id = 7mcA
// module chunks = 1